import React from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogFooter,
} from 'components/ui/dialog'

export interface Props {
	className?: string
	children: any
	title: string | null
	openPopup: boolean
	actions?: any
	popupWidth?: string
	setOpenPopup?: Function
	isFullWidth?: boolean
	icon?: React.ReactNode
	description?: string
}

const PopupRTE = ({
	className = '',
	title,
	children,
	actions,
	popupWidth = '',
	openPopup,
	setOpenPopup,
	isFullWidth = false,
	icon,
	description,
}: Props) => {
	const handleClose = () => {
		if (setOpenPopup) setOpenPopup(false)
	}

	return (
		<Dialog open={openPopup} onClose={handleClose}>
			<DialogContent
				data-testid="Popup"
				className={`${isFullWidth ? 'w-full' : ''} ${
					popupWidth === 'lg' ? 'max-w-4xl' : 'max-w-2xl'
				} min-w-[16rem] py-0.5 pb-0.5 ${className}`}
			>
				<DialogHeader>
					<div className="flex items-center gap-3">
						{icon && (
							<div className="w-10 h-10 rounded-lg flex items-center justify-center bg-[#0080fe]/10 text-[#0080fe]">
								{icon}
							</div>
						)}
						<div className="flex-1">
							<DialogTitle>{title}</DialogTitle>
							{description && (
								<DialogDescription>{description}</DialogDescription>
							)}
						</div>
					</div>
				</DialogHeader>
				<div className="px-5 py-2">
					{typeof children === 'string' ? (
						<p className="text-sm text-gray-500">{children}</p>
					) : (
						children
					)}
				</div>
				{actions && (
					<DialogFooter className="mt-2">{actions}</DialogFooter>
				)}
			</DialogContent>
		</Dialog>
	)
}

export default PopupRTE
